import React, { useCallback, useRef, useState, useEffect } from 'react'
import {
  AppBar,
  Toolbar,
  Box
} from '@mui/material'
import { useFormFactor, useIsOnTrial } from '../../hooks'
import { useStyles } from './style'
import { PaidConsumerMobileDrawer } from './navigation/paid-consumer-mobile-drawer'
import { PaidConsumerProfileMenu } from './navigation/paid-consumer-profile-menu'
import { MobileNavigation, DesktopNavigation } from './navigation'
import { ChatAIWhite } from '../icons'
import { useMindset } from '../mindset-agent/mindset-context'
import { useSelector } from 'react-redux'
import { contentSlice, subscriptionSlice, userSlice } from '../../reducers'
import { TrialBanner } from './navigation/trial-banner'
import GleapBubble from '../gleap/gleap-bubble'
import { useEvent } from '@emerald-works/react-event-bus-client'

const AppToolbarPaidConsumer = () => {
  const { isMobile, isSmallTablet, isLargeTablet } = useFormFactor()
  const isTablet = isSmallTablet || isLargeTablet
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null)
  const [searchExpanded, setSearchExpanded] = useState(false)
  const appBarRef = useRef(null)
  const profile = useSelector(userSlice.selectors.selectProfile)
  const accountInfoLoaded = useSelector(
    subscriptionSlice.selectors.selectAccountInfoLoaded
  )

  const { isOnTrial } = useIsOnTrial()

  const isMeteringEnabled = useSelector(contentSlice.selectors.selectIsMeteringEnabled)
  const isPreview = useSelector(contentSlice.selectors.selectIsPreview)
  const { shouldShowMindsetAi, openMindset, isOpen, isMindesetExcludedRoute } = useMindset()

  const [subscriptionGetAccountInfo] = useEvent([
    subscriptionSlice.eventBus.subscriptionGetAccountInfo
  ])

  const classes = useStyles({ isMeteringEnabled })

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const handleProfileMenuOpen = (event) => {
    setProfileMenuAnchor(event.currentTarget)
  }

  const handleProfileMenuClose = () => {
    setProfileMenuAnchor(null)
  }

  const handleSearchToggle = () => {
    setSearchExpanded(!searchExpanded)
  }

  const handleShowMindset = useCallback((evt, source) => {
    openMindset({
      from: source
    })
  }, [openMindset])

  useEffect(() => {
    if (!accountInfoLoaded && profile?.username) {
      subscriptionGetAccountInfo.trigger({
        accountId: profile.username,
        invalidateCache: accountInfoLoaded
      })
    }
  }, [accountInfoLoaded, profile?.username, subscriptionGetAccountInfo])

  return (
    <>
      <AppBar
        ref={appBarRef}
        position='sticky'
        className={classes.appBar}
        elevation={0}
      >
        {isOnTrial && <TrialBanner />}
        <Toolbar className={classes.toolbar} disableGutters>
          {isMobile || isTablet
            ? (
              <MobileNavigation
                onMenuToggle={handleMobileMenuToggle}
                onProfileMenuOpen={handleProfileMenuOpen}
                onSearchToggle={handleSearchToggle}
                searchExpanded={searchExpanded}
                isTablet={isTablet}
              />
              )
            : (
              <DesktopNavigation
                onProfileMenuOpen={handleProfileMenuOpen}
              />
              )}
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <PaidConsumerMobileDrawer
        open={mobileMenuOpen}
        onClose={handleMobileMenuToggle}
      />

      {/* Profile Menu */}
      <PaidConsumerProfileMenu
        anchorEl={profileMenuAnchor}
        open={Boolean(profileMenuAnchor)}
        onClose={handleProfileMenuClose}
      />

      {/* Mindset AI Bubble */}
      {(shouldShowMindsetAi && !isPreview && !isOpen && !isMindesetExcludedRoute) && (
        <Box
          className={classes.mindsetBubble}
          onClick={(evt) => handleShowMindset(evt, 'bubble')}
          data-test='mindset-ai-bubble'
          style={isMeteringEnabled ? { bottom: '140px' } : {}}
        >
          <ChatAIWhite />
        </Box>
      )}
      <GleapBubble />
    </>
  )
}

export default AppToolbarPaidConsumer
